var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0dbafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16ebc3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0dbafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15e7c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60074",
    "data-name": "Group 60074",
    transform: "translate(2478 4789)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16321",
    "data-name": "Rectangle 16321",
    width: 100,
    height: 100,
    transform: "translate(-2478 -4789)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2479.944 -4790.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17651",
    "data-name": "Path 17651",
    d: "M51.972,2a49.972,49.972,0,1,0,49.972,49.972A49.972,49.972,0,0,0,51.972,2Zm0,91.616A41.643,41.643,0,1,1,93.616,51.972,41.643,41.643,0,0,1,51.972,93.616Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17652",
    "data-name": "Path 17652",
    d: "M11.738,21.894a4.164,4.164,0,0,0-4.164,4.164V54.376a4.164,4.164,0,1,0,8.329,0V26.059a4.164,4.164,0,0,0-4.166-4.165Zm0-17.074A4.414,4.414,0,0,0,7.49,9.151v.666a3.914,3.914,0,0,0,4.248,3.914A4.331,4.331,0,0,0,15.9,9.568v-1A3.748,3.748,0,0,0,11.738,4.82Z",
    transform: "translate(40.234 20.5)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderInfo);
export default __webpack_public_path__ + "static/media/loader_info.189bd2a6f792764facaedf6ae1d81ee3.svg";
export { ForwardRef as ReactComponent };